module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-standside-2850.dc50b602.svg";